import { AddOutlined } from "@mui/icons-material";
import { Box, Dialog } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { CustomButton, FilterBar, TableData } from "components";
import { errorAlert } from "helpers/alerts";
import { currencyFormatter } from "helpers/util";
import { setTitle } from "redux/slices/uiSlice";
import { getAbonosService } from "services/abonos/abonosService";
import { type } from "@testing-library/user-event/dist/type";
import DialogModal from "components/modal/DialogModal";

const AbonosScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  useEffect(() => {
    dispatch(setTitle("Abonos"));
    // eslint-disable-next-line
  }, []);

  const handlerSubmit = async (data) => {
    setLoading(true);
    getAbonosService(data)
      .then((result) => setList(result))
      .catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        showButton={false}
        showTitle={false}
        defaultValues={{
          status: "Pendiente",
        }}
        filters={[
          {
            type: "select",
            name: "status",
            label: "Estado",
            data: [
              { id: "Pendiente", name: "Pendiente" },
              { id: "Aplicado", name: "Aplicado" },
              { id: "Descartado", name: "Descartado" },
            ],
          },
        ]}
      />
      <Box mt={-5}>
        <TableData
          loading={loading}
          dataRows={list}
          dataTitle={[
            "Banco Origen",
            "Banco Destino",
            "Importe",
            "Bolsa destino",
            "Referencia",
            "Deposito",
            "Recibo",
            "Estado",
          ]}
          formatter={(row) => [
            row?.bankOrigin || "-",
            row?.bankDestination?.bank || "-",
            row?.amount ? currencyFormatter.format(row?.amount || 0) : "-",
            row?.bagType || "-",
            row?.reference || "-",
            {
              type: "text",
              value: row.date ? moment(row.date).format("DD/MM/YYYY HH:mm:ss") : "",
              title: `Hora de envío de notificación: ${moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss")}`,
            },
            row?.receipt ? {
              type: "button",
              value: "Ver",
              action: () => setDialog({
                open: true,
                title: "Recibo de abono",
                body: <img src={`/v3/file/${row.receipt}/`} alt="Recibo de abono" style={{ width: "100%" }} />,
                onClose: () => setDialog({ open: false, title: '', body: '' }),
              }),
            } : null,
            row?.status || "-",
          ]}
          headerButtons={[
            <CustomButton
              dark={true}
              key={"newAbono"}
              name={"Nuevo Abono"}
              icon={<AddOutlined />}
              click={() => navigate("../nuevo")}
            />
          ].filter(Boolean)}
        />
      </Box>
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
    </>
  );
};

export default AbonosScreen;
